import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import SM from 'services/ServiceManager';
import ServerError from 'errors/ServerError';
import { useState } from 'react';
import notification from 'ui-library/components/Notification';

export const useGetCustomService = ({
    service, api, payload, enabled = false, gcTime = 3 * 60 * 1000, staleTime = 2 * 60 * 1000, refetchOnWindowFocus = true,
} : {service: string, api: string, payload?: any, enabled?: boolean, gcTime?: number, staleTime?: number, refetchOnWindowFocus?: boolean}) => {
    const [error, setError] = useState<any>(null);
    const { t } = useTranslation();

    const getData = async () => {
        try {
            const result = SM[service](api, Array.isArray(payload) ? payload : [payload]);

            return await (Array.isArray(result) ? result[0] : result);
        } catch (err: any) {
            if (err?.code === 'ERR_CANCELED' || err?.name === 'AbortError' || err?.name === 'CanceledError') {
                return null;
            }
            notification.open({
                content: err?.response?.data || err?.message || `${t('contactGroups.somethingWentWrong')}`,
                type: 'error',
            });
            setError(err);

            return null;
        }
    };

    const {
        data, error: apiError, isLoading, isFetching, refetch, status,
    } = useQuery({
        queryKey: [`getData_${api}`, payload],
        enabled,
        retry: false,
        refetchOnWindowFocus,
        gcTime,
        staleTime,
        queryFn: getData,
    });

    return {
        data: data || null,
        statusCode: data?.status,
        error: apiError ? new ServerError(apiError) : error,
        isLoading,
        isFetching,
        refetch,
        status,
    };
};
